const SDK_VERSION = '7.112.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
